/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
export enum ActionType {
  SendEmail
}

export abstract class WorkflowAction {
  _type: ActionType;
  isChanged?: boolean;
  get type(): ActionType {
    return this._type;
  }

  constructor(type: ActionType, isChanged?: boolean) {
    this._type = type;
    this.isChanged = isChanged;
  }
  abstract isValid(): boolean;
}
